import { useState } from "react";
import { ReactComponent as AddIcon } from "../../images/add.svg";

const Modal = props => {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    if (props.onClose !== undefined) {
      try {
        setShow(false);
        props.onClose();
      } catch (error) {
        console.warn(`Function not provided to Modal onClose`);
      }
    }
  };

  if (!show) {
    return <></>;
  }

  return (
    <div className="modal">
      <div className="modal-wrapper">
        <div className="modal-close" onClick={handleClose}>
          <AddIcon style={{ transform: "rotate(45deg)" }} />
        </div>
        <div className="modal-content">{props.children}</div>
      </div>
    </div>
  );
};

export default Modal;
